namespace advisorop.components.meetinghub {
    export class ComponentController {

        constructor(private meetingHubService: services.MeetingHubService) {

        }

        $onInit(): void {
        }

    }

    class Component implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
            };
            this.controller = [`meetingHubService`, ComponentController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/meeting-hub-module/components/component.html`;
        }
    }
        angular.module(Constants.APP).component(`component`, new Component());
}